// extracted by css-extract-rspack-plugin
export default {"locale_switchers":"FkzQD","localeSwitchers":"FkzQD"};